import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventTicketState }    from 'Redux/Slices/EventTicket/EventTicketSlice';
import { EventTicket }          from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const createEventTicketRequest = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const createEventTicketSuccess = (state: Draft<IEventTicketState>, { type, payload }: PayloadAction<{
  eventTicket: EventTicket
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.eventTicket.id;
  state.entries = { ...state.entries, [payload.eventTicket.id]: payload.eventTicket };
};

export const createEventTicketFailure = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
